export default "__VITE_ASSET__8ad60e7c__"